import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Third Party Provider Setup',
  attributeName: 'thirdPartyProviderSetup',
  fields: [
    {
      attributeName: 'thirdPartyType',
      helpText: 'Third party type, it can be OAUTH or Adobe, the values to fill change',
      type: FormInputTypes.SELECT,
      default: '',
      options: [
        { name: "", value: "" },
        { name: "OAuth", value: "oauth" },
        { name: "beIN -> Adobe", value: "adobe" },
        { name: "NBA -> OPiN", value: "opin" },
        { name: "UFC -> Endeavor", value: "endeavor" },
        { name: "FOX", value: "fox" },
        { name: "PSG", value: "psg" },
        { name: "YBVR", value: "ybvr_firebase" }
      ],
      label: 'Third Party type',
    },
    {
      attributeName: 'authorizationURL',
      helpText: 'External URL of the third-party provider. The app users does a login on this page',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'Authorization URL',
      placeholder: 'Authorization URL...',
      visibleWhen: { "field": "thirdPartyType", "value": "oauth" },
    },
    {
      attributeName: 'tokenURL',
      helpText: 'External URL of the third-party provider to check te login access',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'Token URL',
      placeholder: 'Token URL...',
      visibleWhen: { "field": "thirdPartyType", "value": "oauth" },
    },
    {
      attributeName: 'clientId',
      helpText: 'XMS id inside the third-party environment. It must be provided by the third-party',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'Client ID',
      placeholder: 'Client ID...',
      visibleWhen: { "field": "thirdPartyType", "value": "oauth" },
    },
    {
      attributeName: 'clientSecret',
      helpText: 'XMS password inside the third-party environment. It must be provided by the third-party',
      type: FormInputTypes.TEXT_INPUT.PASSWORD,
      label: 'Client Secret',
      placeholder: 'Client Secred...',
      visibleWhen: { "field": "thirdPartyType", "value": "oauth" },
    },
    {
      attributeName: 'softwareStatement',
      helpText: 'JWT issued by Adobe, used as an access token to access their API.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Software Statement',
      placeholder: 'Software Statement...',
      visibleWhen: { "field": "thirdPartyType", "value": "adobe" },
    },
    {
      attributeName: 'requestorId',
      helpText: 'The Programmer requestorId for which this operation is valid.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Requestor ID',
      placeholder: 'Requestor ID...',
      visibleWhen: { "field": "thirdPartyType", "value": "adobe" },
    },
    // {
    //   attributeName: 'guestUser',
    //   helpText: 'Allows users to access this provider as guests.',
    //   type: FormInputTypes.CHECKBOX,
    //   label: 'Guest access',
    //   visibleWhen: { "field": 'thirdPartyType', "value": 'ybvr_firebase' }
    // },
    {
      attributeName: 'pairing',
      helpText: 'Enables pairing flow for this provider.',
      type: FormInputTypes.CHECKBOX,
      label: 'Pairing',
      visibleWhen: { "field": 'thirdPartyType', "value": 'ybvr_firebase' }
    },
    // {
    //   attributeName: 'guestPairingUrl',
    //   helpText: 'URL used for guest pairing flow.',
    //   type: FormInputTypes.TEXT_INPUT.URL,
    //   label: 'Guest Pairing URL',
    //   placeholder: 'Guest Pairing URL...',
    //   visibleWhen: [{ "field": 'thirdPartyType', "value": 'ybvr_firebase' }, { "field": 'pairing', "value": true }]
    // },
    {
      attributeName: 'externalUrl',
      helpText: 'External URL used for pairing flow.',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'External URL',
      placeholder: 'External URL...',
      visibleWhen: [{ "field": 'thirdPartyType', "value": 'ybvr_firebase' }, { "field": 'pairing', "value": true }]
    },
  ],
};
